import * as React from 'react';

import { translate } from '~l10n/client';

import { proCheck } from '~teacher/util/proCheck';
import HelpTooltip from 'HelpTooltip';
import Input from 'Input';
import Toggle from 'Toggle';

export default class ShortAnswerView extends React.Component {
  render() {
    let c = this.props.controller;
    let m = this.props.model;
    let namesTooltip = null;
    let oneAttemptTooltip = null;
    const canAddRoster = proCheck.canAddRoster();
    const canOneAttemptQuiz = proCheck.canLimitOneAttempt();

    if (m.showNamesTooltip) {
      namesTooltip = {
        location: 'above',
        title: translate('Required'),
        text: translate(
          'Student names must be enabled for rooms with rosters.'
        ),
      };
    }

    if (m.showOneAttemptTooltip) {
      let title = translate('PRO Feature');
      let text = translate(
        'This setting is only available in rooms with rosters.'
      );

      if (canAddRoster && !this.props.hasRoster) {
        title = translate('Roster Required');
      }

      oneAttemptTooltip = {
        location: 'above',
        title: title,
        text: text,
      };
    }

    return (
      <div id="sa-popup-bg" className="modal open">
        <div id="sa-popup-box" className="modal-dialog">
          <div className="modal-header">
            <span className="popup-title">{translate('Short Answer')}</span>
            <a
              className="cancel-button"
              title={translate('Close')}
              onClick={c.cancelClicked}
            >
              <i className="close-popup" data-icon="h" />
            </a>
          </div>
          <div id="sa-popup-content" className="form">
            <Input
              error={false}
              hideTooltip={true}
              id="saQuestion"
              label={translate('Optional Question')}
              maxLength={65000}
              onChange={(event) => c.questionChanged(event.target.value)}
              value={m.question}
            />
            <Toggle
              id="sa-allow-unlimited-responses"
              label={translate('Allow unlimited responses')}
              checked={m.allowRepeats}
              onChange={c.allowRepeatsChanged}
            />
            <Toggle
              id="sa-require-student-names"
              label={translate('Require student names')}
              checked={m.requireNames}
              disabled={this.props.hasRoster}
              onChange={c.requireNamesChanged}
              onClick={(e) => {
                c.requireNamesClicked();
              }}
              tooltip={namesTooltip}
            />
            <Toggle
              id="sa-one-attempt-activity"
              label={translate('One Attempt')}
              checked={m.oneAttempt}
              disabled={!this.props.hasRoster}
              onChange={c.oneAttemptChanged}
              onClick={(e) => {
                c.oneAttemptClicked();
              }}
              tooltip={oneAttemptTooltip}
            >
              <HelpTooltip
                className="short-answer-help-tooltip"
                above={true}
                showProIcon={!canOneAttemptQuiz}
                title={
                  canOneAttemptQuiz
                    ? translate('One Attempt')
                    : translate('PRO Feature')
                }
                text={translate(
                  'Students can only take the quiz once. If they leave and rejoin the room, they will continue the quiz where they left off.'
                )}
              />
            </Toggle>
          </div>
          <div className="modal-footer">
            <button
              id="sa-start-button"
              className="action-button action-button-200"
              onClick={c.startClicked}
            >
              {translate('Start', true)}
            </button>
            <button
              className="secondary-action-button action-button-200"
              onClick={c.cancelClicked}
            >
              {translate('Cancel', true)}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
